var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPyramid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9668 8.75L6.21704 12.25H17.783L16.0332 8.75H7.9668Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.71741 17.25L5.46717 13.75H18.5329L20.2826 17.25H3.71741Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9675 18.75L2.11389 20.4575C1.75959 21.1662 2.27486 22 3.0671 22H20.9329C21.7251 22 22.2404 21.1662 21.8861 20.4575L21.0325 18.75H2.9675Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71667 7.25H15.2833L12.9532 2.5892C12.5605 1.8036 11.4395 1.8036 11.0468 2.5892L8.71667 7.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyramid);
export default __webpack_public_path__ + "static/media/pyramid.c994bc5bfe7509549b4c9fc78b1a3b6a.svg";
export { ForwardRef as ReactComponent };